module.exports = __webpack_public_path__ + "media/images/form-status-revision-requested-b913385c.gif";